import * as React from "react";
import { Button, Row, Col, Icon, InputNumber } from "antd";
import { Label } from "./ForwardInput";
import styled from "styled-components";

const StyledInput = styled(InputNumber)`
  height: 40px !important;
  width: 100% !important;
  background-color: #f2f2f2 !important;
  border: none !important;
  font-size: 14px !important;
  line-height: 32px !important;
  color: #386ee8 !important;
  font-weight: 300 !important;
  text-align: center;
  &::placeholder {
    color: #386ee8 !important;
    font-weight: 300 !important;
  }
  .ant-input-number-handler-wrap {
    display: none;
  }
  input {
    height: 40px !important;
    text-align: center;
  }
`;

type Props = {
  value: number;
  onChange: (value: number) => void;
};

export class QuantityInput extends React.Component<Props> {
  render() {
    return (
      <Row type="flex" align="middle" justify="space-between">
        <Col span="auto">
          <Label> </Label>
          <br />
          <Button
            shape="circle"
            size="small"
            style={{ backgroundColor: "#f2f2f2", border: "none" }}
            onClick={() =>
              this.props.onChange(
                this.props.value > 1 ? this.props.value - 1 : this.props.value
              )
            }
          >
            <Icon type="minus" style={{ color: "#386ee8" }} />
          </Button>
        </Col>
        <Col span={10}>
          <Label>* Anzahl</Label>
          <StyledInput
            value={this.props.value}
            min={0}
            onChange={v => this.props.onChange(v || 1)}
            onKeyDown={handleKeyDown}
          />
        </Col>
        <Col span="auto">
          <Label> </Label>
          <br />
          <Button
            shape="circle"
            size="small"
            style={{ backgroundColor: "#f2f2f2", border: "none" }}
            onClick={() => this.props.onChange(this.props.value + 1)}
          >
            <Icon type="plus" style={{ color: "#386ee8" }} />
          </Button>
        </Col>
      </Row>
    );
  }
}

const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const characterCode = e.key;
  if (
    characterCode === "Backspace" ||
    characterCode === "ArrowRight" ||
    characterCode === "ArrowLeft" ||
    characterCode === "Delete" ||
    characterCode === "Tab"
  )
    return;

  const characterNumber = Number(characterCode);
  if (characterNumber >= 0 && characterNumber <= 9) {
    if (e.currentTarget.value && e.currentTarget.value.length) {
      return;
    } else if (characterNumber === 0) {
      e.preventDefault();
    }
  } else {
    e.preventDefault();
  }
};
